<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6">
        <div style="font-size: 25px; font-weight: 500;">GET IN TOUCH</div>
        <div class="my-3">Feel free to contact us anytime. We will get back to you as soon as possible.</div>
        <div>
          <div v-for="(contact, c) in contacts" :key="c">
            <v-icon size="18">{{ contact.icon }}</v-icon>
            <span class="ml-2">{{ contact.title }}</span>
          </div>  
        </div>
        <div class="d-flex flex-wrap mt-2" style="grid-gap: 10px;">
          <v-btn outlined tile v-for="(social, s) in socials" :key="s" class="primary" dark target="_blank" :href="social.to">
            <v-icon size="20" left>{{ social.icon }}</v-icon>
            <span>{{ social.title }}</span>  
          </v-btn>
        </div>
        <div class="map my-3">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3554.475286597595!2d84.88296471436823!3d27.01514346217793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3993558b671d2faf%3A0x8922702ad8a7ddf5!2sAgram%20InfoTech%20Pvt.%20Ltd%2C%20Panitanki%2C%20Birgunj!5e0!3m2!1sen!2snp!4v1613635250851!5m2!1sen!2snp" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0" title="Agram Infotech"></iframe>  
        </div>
      </v-col>  
      <v-col cols="12" sm="6">
        <div class="form-div pa-8 pa-sm-10 pa-md-12 pa-lg-14">
          <v-form ref="form" lazy-validation v-model="valid" class="form">
            <v-text-field v-model="form.name" label="Full Name" hide-details required outlined :rules="[ v => !!v || 'Full Name is required.' ]" />
            <v-text-field v-model="form.email" label="Email" hide-details required outlined :rules="emailRules" />
            <v-text-field v-model="form.mobile" type="number" hide-details outlined label="Mobile Number" required :rules="[ v => !!v || 'Mobile Number is required.' ]" />
            <v-textarea v-model="form.message" label="Message..." hide-details outlined />
            <v-btn block :disabled="!valid" @click="submit" large outlined>submit</v-btn>       
          </v-form>  
        </div>
      </v-col>  
    </v-row>
  </v-container>  
</template>

<script>
export default {
  data: () => ({
    contacts: [
      { icon: 'mdi-email', title: 'info@agramcloud.com' },
      { icon: 'mdi-phone', title: '+977 98020 57014' },
      { icon: 'mdi-map-marker', title: 'Panitanki-10, Birgunj, Parsa, Nepal' }  
    ],  
    socials: [
      { title: 'Facebook', icon: 'mdi-facebook', to: 'https://www.facebook.com/agraminfotechbirgunj/' },
      { title: 'Twitter', icon: 'mdi-twitter', to: 'https://www.twitter.com/agraminfotech/' },
      { title: 'Instagram', icon: 'mdi-instagram', to: 'https://www.instagram.com/agraminfotech/' },
      { title: 'Linkedin', icon: 'mdi-linkedin', to: 'https://www.linkedin.com/company/agraminfotech/' }, 
    ],
    valid: true,
    form: {
      name: null,
      email: null,
      mobile: null,
      message: null  
    },
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ] 
  }),
  methods: {
    submit() {
      if(this.$refs.form.validate()) {
        this.$store.dispatch({ type: 'sendMessage', form: this.form }).then( () => this.$refs.form.reset())
      } 
    }  
  }
}
</script>

<style scoped>
.map {
  height: 40vh;
  overflow: hidden;
  border-radius: 10px;  
}
.form-div {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .5);  
  overflow: hidden;
  border-radius: 20px;
}
.form {
  display: flex;
  flex-direction: column;
  grid-gap: 20px;  
}
button { 
  animation: none !important; 
  background-color: transparent; 
}
</style>